import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "wrapper-shared-samples" }
const _hoisted_2 = { class: "above-table" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Searcher = _resolveComponent("Searcher")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("p", null, "Muestras compartidas", -1)),
      _createVNode(_component_Searcher, {
        placeholder: "Buscar por referencia, empleado, cliente o tipo...",
        search: _ctx.query,
        "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event))
      }, null, 8, ["search"]),
      _createElementVNode("a", {
        href: _ctx.route,
        class: "wrapper-button"
      }, [
        _createVNode(_component_StandardButton, { buttonLabel: 'Exportar a Excel' })
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("table", null, [
      _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Referencia"),
          _createElementVNode("th", null, "Descripción"),
          _createElementVNode("th", null, "Código empleado"),
          _createElementVNode("th", null, "Usuario empleado"),
          _createElementVNode("th", null, "Código cliente"),
          _createElementVNode("th", null, "Fecha"),
          _createElementVNode("th", null, "Tipo")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSharedInfo, (sharedSample, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(sharedSample.idReference), 1),
            _createElementVNode("td", null, _toDisplayString(sharedSample.description), 1),
            _createElementVNode("td", null, _toDisplayString(sharedSample.emplid), 1),
            _createElementVNode("td", null, _toDisplayString(sharedSample.name), 1),
            _createElementVNode("td", null, _toDisplayString(sharedSample.clientCode), 1),
            _createElementVNode("td", null, _toDisplayString(sharedSample.sharedTime), 1),
            _createElementVNode("td", null, _toDisplayString(sharedSample.type), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}